exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".listGroup__item[data-v-7c5d2c99]{border-bottom:1px solid #eee;padding:8px 0}.media[data-v-7c5d2c99]{color:#4f4f4f}.media[data-v-7c5d2c99]:hover{text-decoration:none}.media__image[data-v-7c5d2c99]{margin-right:16px}.media__image>img[data-v-7c5d2c99]{width:72px;height:72px;-o-object-fit:cover;object-fit:cover;border-radius:36px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7c5d2c99","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/CounselorsList.vue
// module id = /jwA
// module chunks = 0